










import { defineComponent } from '@nuxtjs/composition-api';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import { PAGINATION_DEFAULT_RESULTS_LIMIT } from '~/constants/pagination';
import { usePagination } from '~/composables/usePagination';

export default defineComponent({
  name: 'PaginationReviews',
  components: {
    Button,
  },
  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
  },
  setup(props, { emit }) {
    const {
      currentPage,
      totalPages,
      getLoadMoreParams,
    } = usePagination(props.totalResultsAmount, props.perPage);

    const onLoadMore = () => {
      const pageChangeParams = getLoadMoreParams();
      emit('onLoadMore', pageChangeParams);
    };

    return {
      currentPage,
      totalPages,
      onLoadMore,
    };
  },
});
